// src/locales/en/messageCenterCommission.js
export const messageCenterCommission = {
  pageTitle: 'Message Center Commission',
  pageDescription: 'Finalize month-end commission and review past commission runs',
  failedToLoadCommissions: 'Failed to load commission records',
  finalizeLastMonth: 'Finalize Last Month',
  finalize: 'Finalize',
  finalizeConfirmMessage: 'This will finalize commission for {month} and cannot be undone. Continue?',
  finalizeSuccess: 'Commission finalized successfully',
  finalizeFailed: 'Failed to finalize commission',
  filterByMonth: 'Month',
  allMonths: 'All months',
  settlementMonth: 'Settlement Month',
  totalCommission: 'Total Commission',
  status: {
    pending: 'Pending Review',
    completed: 'Completed',
  },
  finalizedAt: 'Finalized At',
  noCommissionsYet: 'No commission records yet',
  noCommissionsYetDescription: 'Finalize last month to create the first commission record',
  detailsPageTitle: 'Commission Details',
  detailsPageDescription: 'Staff commission breakdown for this settlement month',
  failedToLoadCommission: 'Failed to load commission record',
  markCompleted: 'Mark as Completed',
  completeConfirmMessage: 'Mark this commission as completed? This cannot be undone.',
  completeSuccess: 'Commission marked as completed',
  completeFailed: 'Failed to mark commission as completed',
  finalizeMonth: 'Finalize Month',
  selectMonthToFinalize: 'Select month to finalize',
  reverse: 'Reverse Finalization',
  reverseConfirmMessage: 'This will reverse the finalized commission for {month} and permanently delete its commission records. Continue?',
  reverseSuccess: 'Commission finalization reversed successfully',
  reverseFailed: 'Failed to reverse commission finalization',
  staffMember: 'Staff Member',
  userId: 'User ID',
  commissionAmount: 'Commission Amount',
  finalizedBy: 'Finalized By',
  noStaffCommissionRecords: 'No staff commission records found',
  staffPageTitle: 'Staff Commission',
  staffPageDescription: 'View commission earned per shift for a given month',
  failedToLoadStaffReport: 'Failed to load staff commission report',
  filterByUser: 'Staff Member',
  allUsers: 'All staff',
  estimate: 'Estimate',
};
